export default "__VITE_ASSET__2a6ccf50__"